{
	"title": "Gewährleistung der Rechenschaftspflicht durch Einrichtung einer Carbon Bank",
	"description": "Heidelberg Materials hat umfassende Maßnahmen ergriffen, um die Glaubwürdigkeit der durch unser CCS-Zementwerk erzeugten Kohlenstoffreduktionen zu gewährleisten. Um jede Möglichkeit einer Doppelbuchung auszuschließen, haben wir eine sichere virtuelle Carbon Bank auf einem öffentlichen Distributed Ledger implementiert.",
	"traceabilityTitle": "Rückverfolgbarkeit von Kohlenstoffreduktionen"
}
